import { useState } from "react";
import styles from "./CreditCard.module.css";
import Card from "react-credit-cards-2";
import axios from "axios";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../../../redux/userSlice";
import { toast } from "react-toastify";

function CreditCard({ totalPrice }) {
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [number, setNumber] = useState("");
  const [name, setName] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvc, setCvc] = useState("");
  const [issuer, setIssuer] = useState("");
  const [focused, setFocused] = useState("");
  // eslint-disable-next-line
  const [formData, setFormData] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const purchaseSuccessful = () =>
    toast.success("Your purchase was made successfully!");
  const user = useSelector((state) => state.user);

  const handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      setIssuer(issuer);
    }
  };
  const handleInputFocus = ({ target }) => {
    setFocused(target.name);
  };

  const handleInputChange = ({ target }) => {
    if (target.name === "number") {
      setNumber(formatCreditCardNumber(target.value));
    } else if (target.name === "expiry") {
      setExpiry(formatExpirationDate(target.value));
    } else if (target.name === "name") {
      setName(target.value);
    } else if (target.name === "cvc") {
      setCvc(formatCVC(target.value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = [...e.target.elements]
      .filter((d) => d.name)
      .reduce((acc, d) => {
        acc[d.name] = d.value;
        return acc;
      }, {});

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/orders`,
        method: "POST",
        headers: { Authorization: `Bearer ${user.info.token}` },
        data: {
          user: user.info.token,
          products: user.products,
          shippingAddress: `${address}, ${city}, ${country} `,
          orderTotal: (totalPrice + 60).toFixed(),
        },
      });
      if (response) {
        navigate("/");
        purchaseSuccessful();
        dispatch(clearCart());
      }
    } catch (error) {
      console.log(error);
    }
    setFormData(formData);
    e.target.reset();
  };

  return (
    <form className={styles.card_form} onSubmit={handleSubmit}>
      <div id="shippingInfo">
        <div className={"row g-3 " + styles.card_form}>
          <div className="col-12">
            <input
              type="text"
              className={"form-control " + styles.input}
              id="address"
              value={address}
              name="address"
              onChange={(event) => setAddress(event.target.value)}
              placeholder="Address"
            />
          </div>
          <div className="col-md-6">
            <input
              type="text"
              value={city}
              className={"form-control " + styles.input}
              id="city"
              name="city"
              onChange={(event) => setCity(event.target.value)}
              placeholder="City"
            />
          </div>
          <div className="col-md-6">
            <input
              type="text"
              value={country}
              className={"form-control " + styles.input}
              id="country"
              name="country"
              onChange={(event) => setCountry(event.target.value)}
              placeholder="Country"
            />
          </div>
        </div>
      </div>
      <hr className={styles.hr} />
      <div key="Payment">
        <h3 className={"text-center " + styles.title}>
          PAY DIRECTLY WITH CREDIT/DEBIT CARD
        </h3>
        <div className={styles.app_payment}>
          <Card
            name={name}
            number={number}
            expiry={expiry}
            cvc={cvc}
            focused={focused}
            callback={handleCallback}
            preview={true}
            issuer="visa"
          />
          <div className={"row g-3 mt-2 " + styles.card_form}>
            <div className="form-group">
              <input
                value={number}
                type="tel"
                name="number"
                className={"form-control mb-4 " + styles.input}
                placeholder="Card Number"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
              />
            </div>
            <div className="form-group">
              <input
                value={name}
                type="text"
                name="name"
                className={"form-control mb-4 " + styles.input}
                placeholder="Name"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
              />
            </div>

            <div className="col-6">
              <input
                value={expiry}
                type="tel"
                name="expiry"
                className={"form-control " + styles.input}
                placeholder="Valid Thru"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
              />
            </div>
            <div className="col-6">
              <input
                value={cvc}
                type="tel"
                name="cvc"
                className={"form-control " + styles.input}
                placeholder="CVC"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
              />
            </div>
          </div>
          <input type="hidden" name="issuer" value={issuer} />
          <div className="form-actions">
            <button
              type="submit"
              className={"btn w-100 mt-4 " + styles.checkout_btn}
            >
              PAY
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default CreditCard;
